<template>
    <v-slide-y-transition mode="out-in">
    <div id="acc-periode-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg6>          
            <v-card pa-0>
              
              <v-divider></v-divider>
              <v-card-text class="">
                  <v-form v-model="valid">
                      <v-layout row wrap>
                        <v-flex lg12 sm12>
                          <v-text-field
                              label="ID"
                              name="id"                              
                              v-model="formModel.id"
                              v-validate="'required'"
                              data-vv-name="id"     
                              :error-messages="errors.collect('id')"  
                              required
                          ></v-text-field>  
                        </v-flex>
                        <v-flex lg12 sm12>
                          <v-text-field
                              label="Name"
                              name="name"                              
                              v-model="formModel.name"
                              v-validate="'required'"
                              data-vv-name="name"     
                              :error-messages="errors.collect('name')"  
                              required
                          ></v-text-field>  
                        </v-flex>
                        <v-flex lg12 sm12>
                          <v-text-field
                              label="Email"
                              name="email"                              
                              v-model="formModel.email"
                              v-validate="'required'"
                              data-vv-name="email"     
                              :error-messages="errors.collect('email')"  
                              required
                          ></v-text-field>  
                        </v-flex>                                                    
                        <v-flex sm12 lg12>
                            <div class="form-btn">
                                <v-btn @click="submit" color="primary">Submit</v-btn>
                                <v-btn outline @click="clear">Clear</v-btn>
                              </div>  
                        </v-flex>
                      </v-layout>                                                            
                  </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>  
          
            <v-flex lg6>
                <div class="UsersList">
                    <div class="user" :key="user.id" v-for="user in users">
                      

                      <p class="tasks">{{ user.id }}. {{ user.name }} | {{ user.email }}</p>
                     
                     

                      
                    </div>
                  </div>
                
            </v-flex>  
            
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>
<script>  
export default {  
  data: () => ({
    formModel: {
      id : null,  
      name   : null,     
      email : null,
      
    },
    valid: true,
  }),  
  mounted(){
    this.getItems();  
  },
  computed: {
    users () {
      return this.$store.getters['entities/users/query']().orderBy('id', 'name').get()
    }
  },
  watch: {
    
  },
  methods: {  
    submit () {                
        this.$validator.validateAll();  
        if( !this.errors.any() ) {
            this.$store.dispatch('entities/users/insert', {
                data: { id:this.formModel.id, name: this.formModel.name, email:this.formModel.email}
            })
        }
    },
      
    getItems(){
          
    },
    
    updateData(props){
        window.getApp.$router.push({path:'/master/acc-periode/create', params: props.item, update:true});                
    },
    
    clear () {
      this.formModel = {};
      this.$validator.reset();
    },
    
  }
}
</script>